<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="16"></app-admin-navigation>
    </div>

    <!-- QA Stats -->
    <div class="w-full border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'admin.extraction_qa' |
                    transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <!-- Overview Chart -->
        <div *ngIf="overviewLoaded && overviewData.length > 0" class="w-full p-5 pb-0">
            <div class="border border-border rounded-[16px] p-4">
                <p class="text-sm font-semibold text-neutral-700 mb-2">{{ 'admin.qa.overview_title' | transloco }}</p>
                <div class="h-[250px]">
                    <app-qa-overview-chart [overviewData]="overviewData"></app-qa-overview-chart>
                </div>
            </div>
        </div>

        <!-- Field Error Rates Breakdown -->
        <div class="w-full p-5 pb-0">
            <app-qa-field-errors [toast]="toast" [invoicePeriodType]="invoicePeriodType"></app-qa-field-errors>
        </div>

        <!-- QA Stats Table -->
        <div class="w-full flex flex-col gap-2 p-5">
            <div
                class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen block min-h-[300px] h-full overflow-y-auto rounded-[16px]">
                <table class="table w-full">
                    <thead class="bg-primary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">#</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.timestamp' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.client' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.supplier' | transloco
                                }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.file_name' | transloco
                                }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.energy_type' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.total_fields' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.v1_extracted' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.v2_extracted' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.qa.improvement' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal text-end">{{
                                'archive.overview.action' |
                                transloco }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let stat of qaStats; let i = index">
                            <tr [ngClass]="[expandedRow === i ? 'bg-primary text-white hover:bg-primary-1200' : 'hover:bg-neutral-200']"
                                class="max-h-[50px] hover:cursor-pointer" (click)="toggleDetails(i)">
                                <td class="border-b border-border px-4 py-4">{{ i + 1 }}</td>
                                <td class="border-b border-border px-4 py-4">{{ stat.external_status_updated_at ?
                                    (stat.external_status_updated_at | isoDateTime) : '-' }}</td>
                                <td class="border-b border-border px-4 py-4">{{ stat.client_name || '-' }}</td>
                                <td class="border-b border-border px-4 py-4">{{ stat.supplier_name || '-' }}</td>
                                <td class="border-b border-border px-4 py-4">{{ stat.file_name || '-' }}</td>
                                <td class="border-b border-border px-4 py-4">{{ stat.energy_type }}</td>
                                <td class="border-b border-border px-4 py-4">{{ stat.total_fields }}</td>
                                <td class="border-b border-border px-4 py-4">
                                    <span
                                        [ngClass]="getExtractedClass(stat.extracted_fields_old, stat.extracted_fields_new)">
                                        {{ stat.extracted_fields_old }}/{{ stat.total_fields }}
                                        ({{ stat.accuracy_old | number:'1.1-1' }}%)
                                    </span>
                                </td>
                                <td class="border-b border-border px-4 py-4">
                                    <span
                                        [ngClass]="getExtractedClass(stat.extracted_fields_new, stat.extracted_fields_old)">
                                        {{ stat.extracted_fields_new }}/{{ stat.total_fields }}
                                        ({{ stat.accuracy_new | number:'1.1-1' }}%)
                                    </span>
                                </td>
                                <td class="border-b border-border px-4 py-4">
                                    <span [ngClass]="getImprovementClass(stat)">
                                        {{ getImprovementText(stat) }} {{ 'admin.qa.fields' | transloco }}
                                    </span>
                                    <span class="text-xs text-neutral-400 ml-1">
                                        ({{ stat.accuracy_old | number:'1.1-1' }}% -> {{ stat.accuracy_new |
                                        number:'1.1-1' }}%)
                                    </span>
                                </td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 items-center justify-end">
                                        @if(loadingExpandedRow) {
                                        <span class="loading loading-spinner loading-sm"></span>
                                        }
                                        <button>
                                            <p class="hover:underline"
                                                [ngClass]="expandedRow === i ? 'text-white' : 'text-primary'"
                                                *ngIf="expandedRow !== i">
                                                {{ 'invoice.view_details' | transloco }}</p>
                                            <p class="text-white hover:underline" *ngIf="expandedRow === i">
                                                {{ 'invoice.close_details' | transloco }}</p>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="expandedRow === i">
                                <td colspan="11" class="border-b border-border px-4 py-4" @expandRow>
                                    <app-expanded-extraction-qa [qaData]="expandedQAData"
                                        [toast]="toast" [invoicePeriodType]="invoicePeriodType"></app-expanded-extraction-qa>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="loadedQaStats.length > 0 && !loadMoreHidden">
                            <td colspan="11">
                                <div class="w-full h-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="false" backgroundColor="bg-neutral-500" textColor="text-white"
                                            borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadStatsNewPage()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>